import { ResponsiveBar, BarLayer } from "@nivo/bar";
import { hexColorRegex } from "../../validations/matchers";
import { BarsChartData } from "./BarsChartFunctionalLocationsInterfaces";
import { BarValue } from "./BarValue.view";
import { GraphsNotEnoughDataInMinutes } from "components/GraphsNotEnoughDataInMinutes/GraphsNotEnoughDataInMinutes.view";
import { truncateLongText } from "utilities/utilities";

export const BarsChartFunctionalLocations = ({ data }: BarsChartData) => {
    const keys: string[] = [];
    data.forEach((dataItem) => {
        Object.keys(dataItem).forEach((key) => {
            if (
                key !== "functionalLocation" &&
                key !== "countryCode" &&
                !keys.includes(key) &&
                !key.includes("Color")
            ) {
                keys.push(key);
            }
        });
    });

    const colors: string[] = [];
    data.forEach((dataItem) => {
        return Object.values(dataItem).forEach((value) => {
            if (typeof value === "string" && hexColorRegex.test(value) && !colors.includes(value)) {
                colors.push(value);
            }
        });
    });

    const theme = {
        axis: {
            fontSize: "15px",
            ticks: {
                text: {
                    fontSize: "14px",
                    fontFamily: "Open Sans",
                    fill: "#2B2E3D",
                },
            },
        },
        tooltip: {
            container: {
                display: "none",
            },
        },
    };

    const BarLayers = BarValue as unknown as BarLayer<{ [key: string]: string | number }>;

    return (
        <>
            {data.length < 1 ? (
                <GraphsNotEnoughDataInMinutes />
            ) : (
                <ResponsiveBar
                    data={data}
                    keys={keys}
                    theme={theme}
                    indexBy="functionalLocation"
                    margin={{ top: 0, right: 80, bottom: 50, left: 310 }}
                    padding={0.4}
                    layout="horizontal"
                    enableGridY={false}
                    enableGridX={true}
                    valueScale={{ type: "linear" }}
                    indexScale={{ type: "band", round: true }}
                    colors={colors}
                    innerPadding={1}
                    enableLabel={false}
                    axisTop={null}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: 0,
                        format: (value) => {
                            return truncateLongText(value, 40);
                        },
                    }}
                    axisRight={null}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                        from: "color",
                        modifiers: [["darker", 1.6]],
                    }}
                    legends={[
                        {
                            dataFrom: "keys",
                            anchor: "bottom",
                            direction: "row",
                            justify: false,
                            translateX: 10,
                            translateY: 50,
                            itemsSpacing: 2,
                            itemWidth: 120,
                            itemHeight: 20,
                            itemDirection: "left-to-right",
                            itemOpacity: 0.85,
                            symbolSize: 16,
                            symbolShape: "circle",
                            effects: [
                                {
                                    on: "hover",
                                    style: {
                                        itemOpacity: 1,
                                    },
                                },
                            ],
                        },
                    ]}
                    role="application"
                    layers={["grid", "axes", "bars", BarLayers, "markers", "legends"]}
                />
            )}
        </>
    );
};
